<template>
  <div class="div-main-cards">
    <v-layout wrap>
      <v-flex xs3>
        <v-card
          class="card-total"
          :class="cards.produtosComprar.ativo ? 'card-ativo' : ''"
          :style="
            cards.produtosComprar.ativo ? { backgroundColor: '#043554' } : ''
          "
          @click="selecionarCard(cards.produtosComprar)"
        >
          <v-layout wrap>
            <v-flex xs12>
              <p class="titulo-card text-truncate">{{ cards.produtosComprar.titulo }}</p>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>
              <div class="quantidade-card mr-2">
                <h3 v-if="cardTotalcompra != null">{{ cardTotalcompra }}</h3>
                <v-progress-linear v-else class="mt-2" indeterminate rounded color="red" />
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs3>
        <v-card
          class="card-total"
          :class="cards.produtosSobEncomenda.ativo ? 'card-ativo' : ''"
          :style="
            cards.produtosSobEncomenda.ativo
              ? { backgroundColor: '#043554' }
              : ''
          "
          @click="selecionarCard(cards.produtosSobEncomenda)"
        >
          <v-layout wrap>
            <v-flex xs12>
              <p class="titulo-card text-truncate">{{ cards.produtosSobEncomenda.titulo }}</p>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>
              <div class="quantidade-card mr-2">
                <h3 v-if="cardTotalSobEncomenda != null">{{ cardTotalSobEncomenda }}</h3>
                <v-progress-linear v-else class="mt-2" indeterminate rounded color="red" />
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs3>
        <v-card
          class="card-total"
          :class="cards.produtosTotal.ativo ? 'card-ativo' : ''"
          :style="cards.produtosTotal.ativo ? { backgroundColor: '#043554' } : ''"
          @click="selecionarCard(cards.produtosTotal);dialog_filtros = true;"
        >
          <v-layout wrap>
            <v-flex xs12>
              <p class="titulo-card text-truncate">{{ cards.produtosTotal.titulo }}</p>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>
              <div class="quantidade-card mr-2">
                <div v-if="cardTotal != null" class="d-flex">
                  <h3>{{ cardTotal }}</h3>
                  <v-spacer />
                  <filtros v-model="dialog_filtros" @click.stop />
                </div>
                <v-progress-linear v-else class="mt-2" indeterminate rounded color="red" />
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs3>
        <v-card
          class="card-total"
          :class="cards.produtosTransito.ativo ? 'card-ativo' : ''"
          :style="
            cards.produtosTransito.ativo ? { backgroundColor: '#043554' } : ''
          "
          @click="selecionarCard(cards.produtosTransito)"
        >
          <v-layout wrap>
            <v-flex xs12>
              <p class="titulo-card text-truncate">{{ cards.produtosTransito.titulo }}</p>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>
              <div class="quantidade-card mr-2">
                <h3 v-if="cardTotalTransito != null">{{ cardTotalTransito }}</h3>
                <v-progress-linear v-else class="mt-2" indeterminate rounded color="red" />
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import filtros from "./FiltrosProdutos/Index";

export default {
  props: ["cards"],
  components: {filtros},
  data: () => ({
    dialog_filtros: false
  }),
  created() {
    if (this.fornecedorCompra.produto) {
      this.selecionarCard(this.cards.produtosTotal)
    } else {
      this.selecionarCard(this.cards.produtosComprar);
    }
  },
  computed: {
    ...mapGetters({
      fornecedorCompra: "fornecedor/getFornecedor",
    }),
    ...mapState({
      cardTotalcompra: (state) =>
        state.fornecedor.fornecedor_total_itens_compra,
      cardTotal: (state) => state.fornecedor.fornecedor_total_itens,
      cardTotalTransito: (state) =>
        state.fornecedor.fornecedor_total_itens_transito,
      cardTotalSobEncomenda: (state) =>
        state.fornecedor.fornecedor_total_itens_sobencomenda,
    })
  },
  methods: {
    selecionarCard(cardSelecionado) {
      this.desabilitarTodos();
      this.setarAtivo(cardSelecionado);
      this.$emit("cardSelecionado", cardSelecionado);
    },
    desabilitarTodos() {
      const cards = Object.values(this.cards);
      cards.forEach((card) => {
        card.ativo = false;
      });
    },
    setarAtivo(cardSelecionado) {
      cardSelecionado.ativo = !cardSelecionado.ativo;
    },
  },
};
</script>
<style scoped>
.div-main-cards {
  margin-left: 0%;
}

.card-total {
  margin: 2%;
  height: 60px;
  border-radius: 5px;
}

.titulo-card {
  margin: 4% 0% 0% 8%;
  color: #000000;
}

.quantidade-card {
  margin: 0% 0% 0% 8%;
  color: #000000;
}

.card-ativo {
  background-color: #043554;
}

.card-ativo p,
.card-ativo h3 {
  color: #fbfbfb;
}
</style>
